import { Component, OnInit, Inject, ChangeDetectorRef } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
// import { DigisubservicesService } from 'src/app/services/digisubservices.service';
import { FormBuilder } from '@angular/forms';
import { AdvertisementDetailsComponent } from '../pages/advertisement-details/advertisement-details.component';
import { DigisubservicesService } from 'src/app/services/digisubservices.service';
import * as XLSX from 'xlsx';

@Component({
  selector: 'app-alladd',
  templateUrl: './alladd.component.html',
  styleUrls: ['./alladd.component.scss']
})
export class AlladdComponent implements OnInit {
  AllAdd: any;

  constructor(private dialogRef: MatDialogRef<AlladdComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private service: DigisubservicesService,
    private cdr: ChangeDetectorRef,private fb: FormBuilder
  )
   { }

   district:any
   taluka:any;
   modetype:any
   start_date:any
   end_date:any
   prantname:any
   country:any
   state:any
   duration:any
   delivery_mode: any
   prant_name:any
   sub_type:any
   rep_name:any
   pincode:any
   officer:any
   disrepname:any

  ngOnInit(): void {

    this.start_date=  this.data['date']
    this.end_date=  this.data['endDate']
    this.country= this.data['country']
    this.state=this.data['state']
    this.district= this.data['district_name']
    this.taluka= this.data['taluka_name']
    this.delivery_mode= this.data['delivery_mode']
    this.prant_name= this.data['prant_name']
    this.sub_type = this.data['sub_type']
    this.rep_name= this.data['rep_name']
    this.pincode= this.data['pincode']
    this.officer = this.data['officer']
    this.disrepname = this.data['disrepname']


    // this.modetype= this.data['modeType']


    const req:any = {
    
      "delivery_mode":this.delivery_mode,
      "district":this.district,
      "taluka":this.taluka,
      "start_date": this.start_date,
      "end_date": this.end_date,
      "prant_name": this.prant_name,
      "country": this.country,
      "state": this.state,
      "sub_type":this.sub_type,
      "rep_name":this.rep_name,
      "pincode":this.pincode,
      "officer":this.officer,
      "disrepname":this.disrepname,
    
    }

    console.log(req, "new all address")

    this.service.getgetAllAdd(req).subscribe((data:any) => {
      console.log("pending add=",data);
     this.AllAdd = (data as any);
    });

    console.log("req 2 for add", req)
  }

  
   exportExcel(fileName): void {
          /* table id is passed over here */
          let element = document.getElementById('print-section');
          const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(element);
      
          /* generate workbook and add the worksheet */
          const wb: XLSX.WorkBook = XLSX.utils.book_new();
          XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
      
          /* save to file */
          XLSX.writeFile(wb, fileName + '.xlsx');
        }


    //   show=false 
    //   printPage() {
    //     this.show = true;
    //     const printContent = document.getElementById('print-section')?.outerHTML;
    //     if (!printContent) {
    //         console.error("Print section not found!");
    //         return;
    //     }
    
    //     const printWindow = window.open('', '', 'width=1400,height=1000,top=50,left=50,scrollbars=yes');
    
    //     if (printWindow) {
    //         printWindow.document.open();
    //         printWindow.document.write(`
    //             <html>
    //                 <head>
    //                     <title>Print Report</title>
    //                     <style>
    //                         @media print {
    //                             @page {
    //                                 size: A3 landscape;
    //                                 margin: 5mm;
    //                             }
    //                             * {
    //                                 box-sizing: border-box;
    //                             }
    //                             html, body {
    //                                 font-family: Arial, sans-serif;
    //                                 font-size: 12px;
    //                                 margin: 0;
    //                                 padding: 0;
    //                                 line-height: 1.2;
    //                             }
    //                             table {
    //                                 width: 100%;
    //                                 border-collapse: collapse;
    //                                 table-layout: fixed;
    //                                 margin: 0;
    //                             }
    //                             tr, td, th {
    //                                 padding: 2px;
    //                                 margin: 0;
    //                                 border: 1px solid black;
    //                                 text-align: center;
    //                                 vertical-align: top;
    //                                 page-break-inside: avoid;
    //                             }
    //                             .noPrint {
    //                                 display: none;
    //                             }
    //                         }
    //                     </style>
    //                 </head>
    //                 <body>
    //                     <div id="print-section">
    //                         ${printContent}
    //                     </div>
    //                     <script>
    //                         window.onload = function() {
    //                             window.print();
    //                             setTimeout(() => { window.close(); }, 500);
    //                         };
    //                     </script>
    //                 </body>
    //             </html>
    //         `);
    //         printWindow.document.close();
    //     } else {
    //         console.error("Failed to open print window.");
    //     }
    // }
    

}
